'use client'
import React, { FC, ReactElement } from 'react'
import styles from './Button.module.css'
import classNames from 'classnames'
import Loading from '@/components/circle-loading'

const Button: FC<{
	children: React.ReactNode
	className?: string
	loadingClassName?: string
	type?: 'button' | 'submit' | 'reset'
	onClick?: (evt: any) => void
	disabled?: boolean
	loading?: boolean
	size?: 'none' | 'small' | 'medium' | 'large' | 'larger' | 'x-large'
	background?:
		| 'white'
		| 'black'
		| 'transparent'
		| 'twitter-blue'
		| 'gray'
		| 'gradient-epic'
		| 'outlined-gradient'
		| 'orange'
}> = (props): ReactElement => {
	return (
		<button
			disabled={props.disabled}
			onClick={props?.onClick}
			className={classNames(
				{
					[(props.className as any)]: !!props.className,
					[styles.small]: props?.size === 'small',
					[styles.medium]: props?.size === 'medium',
					[styles.large]: props?.size === 'large',
					[styles.larger]: props?.size === 'larger',
					[styles.xlarge]: props?.size == 'x-large',
					[styles.white]: props?.background === 'white',
					[styles.black]: props?.background === 'black',
					[styles.gray]: props?.background === 'gray',
					[styles.gradientEpic]: props?.background === 'gradient-epic',
					[styles.twitterBlue]: props?.background === 'twitter-blue',
					[styles.orange]: props?.background === 'orange',
					[styles.transparent]: props?.background === 'transparent',
					[styles.disabled]: !!props?.disabled
				},
				styles.root
			)}
			type={props.type || 'button'}
		>
			{props?.loading ? <Loading className={props?.loadingClassName} /> : props.children}
		</button>
	)
}

export default Button
